export default __webpack_public_path__ + "static/media/upload.107aa053.svg";